import React from "react";
import { MainLayout } from "../styles/Layouts";
import Resume from "../components/Resume";

function ResumePage() {
  return (
    <MainLayout>
      <Resume />
    </MainLayout>
  );
}

export default ResumePage;
